<script lang="ts" setup>
import AppCheckbox from '../appCheckbox/AppCheckbox.vue';
import AppSpinner from '../appLoaders/appSpinner/AppSpinner.vue';

interface AppToggleLabelProps {
  isLoading: boolean;
  checked: boolean;
  isDisabled?: boolean;
}

const props = defineProps<AppToggleLabelProps>();

interface AppToggleLabelEmits {
  (event: 'change', value: boolean): void;
}

const emit = defineEmits<AppToggleLabelEmits>();
</script>

<template>
  <div class="app-toggle-label">
    <AppSpinner v-if="props.isLoading" />
    <AppCheckbox
      v-else
      :checked="props.checked"
      theme="grey"
      :is-disabled="props.isDisabled"
      size="small"
      @change="emit('change', $event)"
    >
      <slot />
    </AppCheckbox>
  </div>
</template>

<style scoped lang="scss">
.app-toggle-label {
  --min-size: 42px;
  box-sizing: border-box;
  width: fit-content;
  min-width: var(--min-size);
  min-height: var(--min-size);

  align-items: center;
  justify-content: center;
  display: flex;

  background-color: var(--color-white);
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.15);

  border-radius: var(--border-radius-8);
  padding: var(--spacing-8);
  white-space: nowrap;
}
</style>
